import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  headerCell: {
    textAlign: 'center',
    textWrap: 'balance'
  },
  taskGroupName: {
    display: 'inline-block',
    fontWeight: 'bolder',
    fontSize: '1rem',
    color: '#3C419A',
    overflow: 'hidden',
    width: '160px',
    paddingTop: '5px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  taskGroupDates: {
    fontSize: '1rem',
    color: '#3C419A',
    width: 'auto',
    whiteSpace: 'initial',
    wordWrap: 'break-word',
    padding: '1px 0 10px 0',
  },
  dateCell: {
    textAlign: 'center',
    '& .MuiInput-underline, & .MuiInput-underline:before, & .MuiInput-underline:hover:not(.Mui-disabled):before': {
      border: 'none',
    },
    '.& .MuiInput-underline:before': {
      transition: 'none',
    },
  },
  pickDateIcon: {
    display: 'inline-block',
    width: '18px',
    height: '18px',
    borderRadius: '50%',
    padding: '5px',
    '&:hover': {
      backgroundColor: '#CACAFC4D',
    },
  },
  dateAndTimeFormatted: {
    color: '#2C2D3E',
    fontSize: '12px',
    position: 'relative',
    display: 'inline-block',
    width: '110px',
    paddingBottom: '7px',
  },
  dateFormatted: {
    width: '50px',
    display: 'inline',
  },
  timeFormatted: {
    width: '50px',
    display: 'inline',
  },
  dateCloseButton: {
    fontSize: '14px',
    marginLeft: '5px',
    position: 'relative',
    top: '6px',
    cursor: 'pointer',
    borderRadius: '50%',
    padding: '3px',
    marginRight: '-10px',
    '&:hover': {
      backgroundColor: '#CACAFC4D',
    },
  },
  unconfiguredSheet: {
    textAlign: 'center',
    width: '100%',
    paddingTop: '80px',
  },
  unconfiguredSheetIcon: {
    width: '56px',
    height: '56px',
  },
  unconfiguredText: {
    width: '400px',
    fontFamily: 'Roboto',
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '24px',
    color: '#3C419A',
    wordWrap: 'break-word',
    textAlign: 'center',
    margin: '20px auto 0 auto',
  },
  unconfiguredHeader: {
    fontWeight: 'bolder',
    fontSize: '16px',
    lineHeight: '19px',
    color: '#2C2D3E',
    marginTop: 2,
    marginBottom: 14,
    fontFamily: 'Roboto',
  },
  disabledIcon: {
    cursor: 'not-allowed !important',
    pointerEvents: 'auto'
  }
}));
